import topHeader from './topHeader'
import footer from './footer'

export default {
  install: (Vue) => {
    Vue.component('top-header', topHeader);
    Vue.component('menu-footer', footer);
  }
}



// WEBPACK FOOTER //
// ./src/components/plugins.js